import React from "react";
import { Table, Image, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { SliderReusableComponent } from "../../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";

export const FastFoodSelectedCategories = (props) => {
  const onWithOutApiCall = (e) => {
    props.history.push({
      pathname: props.history.location.pathname.includes("admin")
        ? "/admin-fastfood/menusetup/selectmenu/selectitems"
        : "/fastfood/menusetup/selectmenu/selectitems",
    });
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div
            id="onboarding-scrollbar"
            className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
          >
            <div className="col-12">
              <BackLogoIconButton
                displayBackText={true}
                displayArrow={true}
                backButtonClicked={
                  props.history.location.pathname.includes("admin")
                    ? "/admin-fastfood/menusetup/selectmenu/categorytype"
                    : "/fastfood/menusetup/selectmenu/categorytype"
                }
              />
            </div>
            <div className="onboarding_process_screen-button-map d-flex justify-content-between flex-column">
              <div>
                <TopTextReusableComponent
                  headingText="Selected Categories"
                  headingParagraph="Edit the categories before submitting"
                />
              </div>
              <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                <Table className="w-100 HideShowTable">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <th style={{ width: "20%" }} className="f11-500">
                        Category
                        <br />
                        ID
                      </th>
                      <th style={{ width: "15%" }} className="f11-500">
                        Icon
                      </th>
                      <th style={{ width: "15%" }} className="f11-500">
                        Name
                      </th>
                      <th style={{ width: "30%" }} className="f11-500">
                        Description
                      </th>
                      <th style={{ width: "20%" }} className="f11-500">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="super_admin_all_users_table_body">
                      <td style={{ width: "20%" }}>
                        <div className="f11-500">#001</div>
                      </td>
                      <td style={{ width: "15%" }}>
                        <img
                          width="40px"
                          src={
                            "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                          }
                          alt="Category ID"
                        />
                      </td>
                      <td style={{ width: "15%" }}>
                        <div className="f11-500">Beverages</div>
                      </td>
                      <td style={{ width: "30%" }}>
                        <div className="f11-500">
                          Lorem ipsum dolor sit amet consectetur ad
                        </div>
                      </td>
                      <td style={{ width: "20%" }}>
                        <div className="d-flex align-items-center">
                          <Button variant="link" className="enIconBtn mr-3">
                            <Image
                              src={require("../../../../../../../../assets/images/UserManagement/Delete.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <NavLink
                            to={
                              props.history.location.pathname.includes("admin")
                                ? "/admin-fastfood/menusetup/selectmenu/editcategories"
                                : "/fastfood/menusetup/selectmenu/editcategories"
                            }
                            variant="link"
                            className="enIconBtn mr-3"
                          >
                            <Image
                              src={require("../../../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </NavLink>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              <div className="onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
                <div>
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="btn-lg btn btn-outline-secondary"
                    buttonText="Cancel"
                    link={
                      props.history.location.pathname.includes("admin")
                        ? "/admin-edit-add-subscription"
                        : "/subscription"
                    }
                  />
                  <ReusableOnboardingButton
                    buttonTitle="Next Button"
                    buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                    buttonText="Set Up Done"
                    buttonType="Submit"
                    onClick={onWithOutApiCall}
                  />
                </div>
                <div className="d-flex justify-content-end ml-5">
                  <NavLink
                    to="/fastfood/menusetup/uploadmenu"
                    className="f12-700 text-red cursor p-0 bg-transparent border-0"
                  >
                    Upload Menu
                  </NavLink>
                  <span className="f10-400 ml-2">
                    Leave Rest to us
                    <br />
                    Charges May Apply
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
            <SliderReusableComponent
              // displayBarButton={true}
              displayHamburger={true}
              paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              bottomImage={require("../../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
